import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: "https://39ff004f0e38423985f39258a6782694@o208856.ingest.sentry.io/5384083",
  environment: document.location.hostname,
  release: import.meta.env.PUBLIC_ENV__COMMIT_ID,
  integrations: [Sentry.dedupeIntegration, Sentry.browserTracingIntegration()],
  debug: document.location.hostname.includes("localhost"),
});

// TODO: Enable StrictMode when react-tel-input-2 stops using UNSAFE_componentWIllREceiveProps
const root = document.getElementById("root");
if (!root) throw new Error("Failed to find the root element");
createRoot(root).render(<App />);
